@if (isInitialized) {
  <oe-flat-widget [title]="component.alias" button
    link="/device/{{edge.id}}/history/{{componentId}}/asymmetricpeakshavingchart"
    [icon]="{name:'trending-down-outline', color: 'normal', size: 'large'}">
  </oe-flat-widget>
}